// components/ChatSidebar.js
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

export default function ChatSidebar({ messages, onSendMessage, isStreaming }) {
  const [newMessage, setNewMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newMessage.trim()) {
      onSendMessage(newMessage);
      setNewMessage('');
    }
  };

  return (
    <div className="chat-sidebar">
      <div className="chat-messages">
        {messages.filter((msg) => msg.role !== 'system').map((msg, index) => (
          <div key={index} className={`message ${msg.role}`}>
            {msg.role === 'assistant' ? (
              <ReactMarkdown
                remarkPlugins={[remarkMath]}
                rehypePlugins={[rehypeKatex]}
              >
                {Array.isArray(msg.content) 
                  ? msg.content.map(c => c.text).join('')
                  : (msg.content && msg.content.text ? msg.content.text : msg.content)}
              </ReactMarkdown>
            ) : (
              Array.isArray(msg.content) 
                ? msg.content.map(c => c.text).join('')
                : (msg.content && msg.content.text ? msg.content.text : msg.content)
            )}
          </div>
        ))}
      </div>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Type your question..."
        />
        <button type="submit" disabled={isStreaming}>Send</button>
      </form>
    </div>
  );
}